import { useLocation } from 'react-router-dom'
import { Capacitor } from '@capacitor/core'
import { useAppSelector } from '../../redux'
import { UserType } from '../../types'
import { getActiveSplits, objectToSnake } from '.'

export const useSegment = () => {
  const w = window as any
  const location = useLocation()
  const { splits } = useAppSelector((state) => state.splits)

  // The web Segment SDK (window.analytics) is loaded via the snippet embedded in
  // public/index.html and auto-initializes from its write key, so there is nothing
  // to initialize at runtime. The native analytics plugin (capacitor-segment-plugin)
  // has been removed; all platforms now route through the web SDK.
  const initialize = async () => {}

  const identify = async (user: UserType) => {
    try {
      if (!user) {
        return
      }

      const fullName = user.displayName || ''
      const firstAndLast = fullName.split(' ')

      const customerData = {
        name: user.displayName,
        firstName: firstAndLast[0] || '',
        lastName: firstAndLast.slice(1).join(' ') || '',
        email: user.email,
        trial: user?.trial,
        has_trialed: user?.hasTrialed,
        facebook_url: user.facebookURL,
        instagram_url: user.instagramURL,
        free: user.free || false,
        stripe_subscription_status: user.stripeSubscriptionStatus,
        subscription_interval: user.subscriptionInterval,
        stripe_customer_id: user.stripeCustomerId,
        role: user.role,
        phone: user.phone,
        course: user.course,
        beta: user.beta || false,
        use: user?.aiOnboarding?.use || 'Personal',
        occupation: user?.aiOnboarding?.occupation || '',
        company: user?.aiOnboarding?.company || '',
        ages: user?.aiOnboarding?.ages || [],
        genders: user?.aiOnboarding?.genders || [],
        occupations: user?.aiOnboarding?.occupations || [],
        voices: user?.aiOnboarding?.voices || [],
        user_created_at: user.createdAt?.seconds ? new Date(user.createdAt.seconds * 1000) : null,
        connected_profiles_amount: user?.socialProfiles?.length
      }

      w.analytics.identify(user?.id, customerData)
    } catch (err) {}
  }

  const track = (eventName: string, properties?: any, options?: any) => {
    try {
      w.analytics.track(
        eventName,
        {
          ...objectToSnake(properties),
          active_splits: getActiveSplits(splits),
          from: location.pathname,
          platform: Capacitor.getPlatform(),
          is_new_platform: true
        },
        options
      )
      w.Intercom('trackEvent', eventName, { ...properties })
    } catch (err) {}
  }

  const page = () => {
    w.analytics.page()
  }

  return { initialize, identify, track, page }
}
